class exports.ZonesDeleteDialogHandler extends DialogHandler

    init: () ->
        @layoutUrl = 'backend/portal/zones/zones/load-delete-dialog'
        @saveUrl = 'backend/portal/zones/zones/delete'
        @classes = 'small_dialog'
        @createDialog()


    afterLoadLayout: (selector, response) ->
        @openDialog()

        if response.status?.type isnt 'success'
            return

        @dialog.find('.save-btn').on 'click', () =>
            @save('Deleting zone...')
